/* @ngInject */
function AuditDetailCardController ($scope, $translate, $q, $state, Utils, CONSTANTS, ToastService, ModalService, AuditService, SegmentService, UdsModalService) {
  const ANALYTICS_ADVANCED_DASHBOARDS_ACCESS_KEY = 'ANALYTICS.ADVANCED_DASHBOARDS'

  const getSendReminderDialogController = () => $q.when(import('../../dialogs/send-reminder/send-reminder-dialog.controller'))
  const getUpgradeCompanyPlanDialogController = () => import('../../../core/dialogs/upgrade-company-plan/upgrade-company-plan-dialog.controller')

  $scope.flags = {
    loading: false,
    isSocialMediaAudit: false
  }
  const api = {
    getSendReminderDialogController,
    getUpgradeCompanyPlanDialogController,
    _sendReminder,
    _generateAuditPdf,
    _showReminderDialog,
    _openUpgradeCompanyPlanDialog
  }
  this.getApi = () => api

  let oldModalReference

  activate()

  function activate () {
    $scope.flags.isSocialMediaAudit = $scope?.audit?.briefing?.name === CONSTANTS.DEFAULT_SOCIAL_MEDIA_BRIEFING_NAME
  }

  $scope.onScheduledClick = function (audit) {
    api._sendReminder(audit)
  }

  $scope.onNonConformClick = function (audit) {
    api._sendReminder(audit)
  }

  $scope.downloadPdf = function (audit) {
    api._generateAuditPdf(audit)
  }

  $scope.footerHasButtons = function () {
    return $('.card-footer .button').length > 0
  }

  $scope.handleOpenAnalytics = (event) => {
    const { pricing } = event.detail
    const briefingSlug = $scope.audit?.briefing?.dataPageSlug

    if (pricing) {
      const featureName = $translate.instant('dataPages.advancedDashboards.featureName')
      const featureSlug = ANALYTICS_ADVANCED_DASHBOARDS_ACCESS_KEY

      return api._openUpgradeCompanyPlanDialog({
        featureName,
        featureSlug
      })
    }

    ModalService.close()

    const analyticsChecklistSlug = 'analytics.dashboard'
    const routeParams = {
      slug: briefingSlug
    }

    if (briefingSlug) {
      SegmentService.track('checklist-finish-analytics-click')

      if (window.clarity) {
        window.clarity('set', 'checklist-finish-analytics-click', null)
      }

      $state.go(analyticsChecklistSlug, routeParams)
    } else {
      $state.go('home')
    }
  }

  function _generateAuditPdf (audit) {
    ToastService.showSuccessToast($translate.instant('generatingPdfText'))

    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_AUDITS_ID_BRIEFING_PDF, [audit.id])

    $scope.flags.loading = true

    Utils.downloadFile(url).then(() => {
      $scope.flags.loading = false
    })
    SegmentService.track('downloaded-checklist', { checklist_id: audit.id })
  }

  function _sendReminder (audit) {
    const today = moment()
    const createdAt = moment(audit.createdAt)
    const days = today.diff(createdAt, 'days')
    const sent = days < 1

    if (sent) {
      api._showReminderDialog(sent)
    } else {
      $scope.flags.loading = true

      AuditService.reminder(audit.id).then(() => {
        $scope.flags.loading = false
        api._showReminderDialog(sent)
      })
    }
  }

  function _showReminderDialog (sent) {
    oldModalReference = ModalService.getCurrentModal()

    api.getSendReminderDialogController().then(({ SendReminderDialogController }) => {
      ModalService.showModal({
        templateId: 'sendReminder.html',
        templateUrl: '/audit/dialogs/send-reminder/send-reminder-dialog.html?$$REVISION$$',
        destroyable: true,
        observeChanges: true,
        allowMultiple: true,
        controller: SendReminderDialogController,
        data: {
          sent
        }
      }).then(() => {
        if (oldModalReference) {
          ModalService.setCurrentModal(oldModalReference)
          ModalService.showCurrentModal()
        }
      })
    })
  }

  function _openUpgradeCompanyPlanDialog (modalData) {
    api.getUpgradeCompanyPlanDialogController().then(({ UpgradeCompanyPlanDialogController }) => {
      const upgradeCompanyPlanDialog = UdsModalService.createModal({
        controller: UpgradeCompanyPlanDialogController,
        modalName: 'upgradeCompanyPlanDialog',
        data: modalData
      })

      upgradeCompanyPlanDialog.open()
    })
  }
}

export { AuditDetailCardController }
